module.exports = __webpack_public_path__ + "img/api-config.141b470f.png";